var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import inviteUserToOrganisation from '../../requests/organisation/inviteUserToOrganisation';
/**
 *
 */
var InviteOrganisationUserCommand = /** @class */ (function (_super) {
    __extends(InviteOrganisationUserCommand, _super);
    function InviteOrganisationUserCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param email string
     *
     * @return {*}
     */
    InviteOrganisationUserCommand.prototype.execute = function (organisation, email) {
        var promise = inviteUserToOrganisation(organisation, email);
        promise.then(this.then);
        promise.catch(this.catch);
        return promise;
    };
    return InviteOrganisationUserCommand;
}(Command));
export default InviteOrganisationUserCommand;
